<template>
  <div class="device-location-map" :style="styleSizeName" :aria-busy="String(locationStatus === 'loading')">
    <el-amap
      v-show="!locationContentHidden"
      building-animation="true"
      :vid="amapId"
      :map-style="mapStyle"
      :zooms="zooms"
      :zoom="zoom"
      pitch="50"
      view-mode="2D"
      rotation="0"
      rotate-enable="true"
      :features="elements"
      :center="center"
      :plugin="plugins"
      :scrollWheel="true"
      ref="amap"
      :events="{ init: locationMapReady }"
    >
      <!-- <el-amap-marker
        v-for="(item, index) in markers"
        :events="item.events"
        :icon="item.icon"
        :position="item.lnglat"
        :key="index"
      ></el-amap-marker> -->
      <el-amap-info-window
        v-if="window"
        retainWhenClose="true"
        :position="window.position"
        :visible="window.visible"
        :content="window.content"
        :offset="window.offset"
        :isCustom="true"
      ></el-amap-info-window>
      <el-amap-polygon
        v-for="(poly, i) in pathPolygon"
        :path="poly"
        fillOpacity="0"
        :key="'polygon_list' + i"
        strokeColor="blue"
        strokeOpacity="1"
        strokeStyle="dashed"
      ></el-amap-polygon>
    </el-amap>
  </div>
</template>
<script>
/* global AMap */
// import mark_b from "./img/mark_b.png";
// import mark_r from "./img/mark_r.png";

import mark_b from "./img/device_b.svg";
import mark_r from "./img/device_r.svg";
// import mark_b from './img/gateway.svg'
import create from "../core/echart/create";
import common from '../core/echart/common'
import locationFeed from '../DeviceMap/feed-mixin'
import { clusterAppearance, clusterElement } from '../DeviceMap/cluster-style'

import mapBorder from "@/assets/100000.json";

export default create({
  name: "Dmap",
  mixins: [locationFeed],
  props: { previewMode: Boolean },
  data() {
    return {
      markers: [],
      labels: [],
      deviceIdList: [],
      pathPolygon: [],
      windows: [],
      window: {
        position: [0, 0],
        visible: false,
        content: "",
        offset: [0, -18],
      },
      subDeviceStatus: "",
      subDeviceCurrentStatus: "",
      subDeviceInfo: "",
      subProperties: "",
      subEvents: "",
      deviceTime: null,
      payloadPropertiesValue: {},
      payloadEventsValue: {},
      // el-amap的plugin只接普通控件；聚合器在地图就绪后用(map, markers, options)创建。
      // SDK预加载MarkerClusterer仍保留，不能把它当作addControl的配置对象传入。
      plugins: [],
      mapMarkers: null,
      messageCache: new Map(),
      propertie: null,
      showIndex: -1,
      showDeviceInfo: null,
      productId: null,
      initMap: false
    };
  },
  computed: {
    mapStyle() {
      return "amap://styles/" + this.option.mapStyle;
    },
    lng() {
      return this.option.lng || 106.557297;
    },
    lat() {
      return this.option.lat || 29.542191;
    },
    center() {
      return [this.lng, this.lat];
    },
    zoom() {
      return this.option.zoom || 15;
    },
    zooms() {
      return [this.option.zoomsMin, this.option.zoomsMax] || [3, 20];
    },
    amapId() {
      return 'amap-' + this._uid;
    },
    elements() {
      return this.option.elements && this.option.elements.length ? this.option.elements : ["bg", "road", "point", "building"];
    },
    markImg() {
      return this.option.markImg || mark_r;
    },
    markerConfig() {
      if (this.previewMode) return () => {};
      try {
        return eval(this.option.markerConfig);
      } catch (error) {
        console.warn(error);
        return () => {};
      }
    },
    infoWindowConfig() {
      if (this.previewMode) return () => {};
      try {
        return eval(this.option.infoWindowConfig);
      } catch (error) {
        console.warn(error);
        return () => {};
      }
    },
  },
  watch: {
    locationContentHidden (value) {
      if (!value) this.$nextTick(() => {
        if (this._isDestroyed || !this.$refs.amap) return
        const map = this.$refs.amap.$$getInstance()
        if (map && typeof map.resize === 'function') map.resize()
        if (map) this.renderDeviceLocations(this.locationRows)
      })
    }
  },
  mounted() {
    // this.destroyed();
    this.updataMapInfo(true);
    // this.getNotDeviceList();
  },
  beforeDestroy () {
    this.destroyed()
    this.clearLocationMarkers()
  },
  methods: {
    renderLocationCluster (context) {
      const look = clusterAppearance(context.count, this.option.pointColor)
      context.marker.setContent(clusterElement(look))
      context.marker.setOffset(new AMap.Pixel(-look.size / 2, -look.size / 2))
      context.marker.setTitle(look.title)
    },
    updateData () {
      if (Number(this.dataType) === 5) {
        if (!this._locationFeed && this._locationMounted) { this._legacyMapSequence = (this._legacyMapSequence || 0) + 1; this.clearMap() }
        return this.updateLocationFeed()
      }
      if (this._locationFeed) { this.stopLocationFeed(); this.clearLocationMarkers() }
      return common.methods.updateData.call(this)
    },
    locationMapReady () { if (Number(this.dataType) === 5) this.renderDeviceLocations(this.locationRows) },
    clearLocationMarkers () {
      if (this._locationCluster) { this._locationCluster.clearMarkers(); this._locationCluster.setMap(null); this._locationCluster = null }
      if (this._locationMarkers) this._locationMarkers.forEach(marker => { marker.off('click'); marker.setMap(null) })
      this._locationMarkers = new Map()
      if (this._locationInfo) this._locationInfo.close()
    },
    renderDeviceLocations (rows) {
      if (Number(this.dataType) !== 5 || !this.$refs.amap) return
      const map = this.$refs.amap.$$getInstance()
      if (!map || typeof AMap === 'undefined') return
      if (!this._locationMarkers) this._locationMarkers = new Map()
      const ids = new Set(rows.map(row => row.deviceId))
      const scope = JSON.stringify(this.parameter)
      if (scope !== this._locationFitScope) { this._locationFitScope = scope; this._locationFitted = false }
      let membershipChanged = false, positionChanged = false
      const icon = this.option.markImg || mark_b, iconChanged = this._locationIcon !== icon
      this._locationMarkers.forEach((marker, id) => {
        if (!ids.has(id)) { marker.off('click'); marker.setMap(null); this._locationMarkers.delete(id); membershipChanged = true }
      })
      rows.forEach(row => {
        let marker = this._locationMarkers.get(row.deviceId)
        if (!marker) {
          marker = new AMap.Marker({ position: [row.lng, row.lat], offset: new AMap.Pixel(-13, -30) })
          marker.on('click', () => {
            const current = marker.getExtData(), content = document.createElement('div')
            content.style.cssText = 'padding:8px;color:#172d3b;font-size:12px;white-space:pre-line'
            content.textContent = current.name + '\n' + current.deviceId + '\n位置时间：' + new Date(current.timestamp).toLocaleString()
            if (this._locationInfo) this._locationInfo.close()
            this._locationInfo = new AMap.InfoWindow({ content, offset: new AMap.Pixel(0, -24) })
            this._locationInfo.open(map, marker.getPosition())
          })
          this._locationMarkers.set(row.deviceId, marker); membershipChanged = true
        }
        const before = marker.getExtData()
        if (!before || before.lng !== row.lng || before.lat !== row.lat) {
          positionChanged = true; marker.setPosition([row.lng, row.lat])
        }
        if (!before || ['name', 'lng', 'lat', 'timestamp', 'propertyId', 'source', 'state'].some(key => before[key] !== row[key])) marker.setExtData(row)
        if (!before || before.name !== row.name) marker.setTitle(row.name)
        if (!before || iconChanged) marker.setIcon(icon)
      })
      this._locationIcon = icon
      const clusterColorChanged = this._locationClusterColor !== this.option.pointColor
      this._locationClusterColor = this.option.pointColor
      if (membershipChanged || clusterColorChanged) {
        if (this._locationCluster) { this._locationCluster.clearMarkers(); this._locationCluster.setMap(null); this._locationCluster = null }
        const markers = Array.from(this._locationMarkers.values())
        if (AMap.MarkerClusterer && markers.length) this._locationCluster = new AMap.MarkerClusterer(map, markers, { gridSize: 80, renderClusterMarker: this.renderLocationCluster })
        else markers.forEach(marker => marker.setMap(map))
      } else if (positionChanged && this._locationCluster && this._locationCluster.setMarkers) this._locationCluster.setMarkers(Array.from(this._locationMarkers.values()))
      if (!this._locationFitted && rows.length && map.setFitView) { map.setFitView(Array.from(this._locationMarkers.values())); this._locationFitted = true }
    },
    updataMapInfo(value) {
      if (Number(this.dataType) === 5) return this.updateLocationFeed()
      if (this.previewMode) return;
      if(this.initMap){
        this.initMap = false;
        return
      }
      this.initMap = value
      const sequence = this._legacyMapSequence = (this._legacyMapSequence || 0) + 1
      this.getDeviceList().then(() => {
        if (Number(this.dataType) === 5 || this._isDestroyed || sequence !== this._legacyMapSequence) return
        this.getRealTimeDeviceInfo();
        this.$nextTick(() => {
          const mapInstance = this.$refs.amap.$$getInstance(); // 原生地图对象

          const clusterMarkers = this.markers.map((item) => {
            const marker = new AMap.Marker({
              position: item.lnglat,
              icon: item.icon,
              offset: new AMap.Pixel(-13, -30),
              extData: item,
            });

            // ✅ 手动绑定点击事件（如果原有定义）
            if (item.events && typeof item.events.click === "function") {
              marker.on("click", item.events.click);
            }

            return marker;
          });
          this.mapMarkers = clusterMarkers;

          // 创建 MarkerClusterer 实例
          this.cluster = new AMap.MarkerClusterer(mapInstance, clusterMarkers, {
            gridSize: 80,
            renderClusterMarker: this.renderLocationCluster,
            // maxZoom: 18,
            // zoomOnClick: false,
          });

          // 聚合点击事件
          this.cluster.on("click", (e) => {
            if (e.count === 1) {
              // 这里可以直接触发单点点击
              e.markers[0].emit("click", { target: e.markers[0] });
            } else {
              mapInstance.setZoomAndCenter(mapInstance.getZoom() + 2, e.lnglat);
            }
          });

          // 自定义点击事件（如打开 infoWindow）
          // this.cluster.on("click", (e) => {
          //   console.log(e);
          //   const clickedMarker = e.clusterData[0];
          //   const item = clickedMarker.getExtData();

          //   // 显示 infoWindow
          //   this.window.position = item.lnglat;
          //   this.window.content = this._createInfoWindow(
          //     this.infoWindowConfig1(item.deviceInfo, mapInstance)
          //   );
          //   this.window.visible = true;
          // });
        });
      });
    },
    //获取边界点
    getNotDeviceList() {
      // console.log(mapBorder);
      mapBorder.features.forEach((feature) => {
        const geometry = feature.geometry;
        this.pathPolygon = [];
        if (geometry.type === "Polygon") {
          // Polygon 的结构是：[ [ [lng, lat], [lng, lat], ... ] ]
          geometry.coordinates.forEach((polygon) => {
            this.pathPolygon.push(polygon);
          });
        } else if (geometry.type === "MultiPolygon") {
          // MultiPolygon 的结构是： [ [ [ [lng, lat], [lng, lat], ... ] ], ... ]
          geometry.coordinates.forEach((multi) => {
            multi.forEach((polygon) => {
              this.pathPolygon.push(polygon);
            });
          });
        }
      });
      // window
      //   .axios({
      //     // url: '/jetlinks/geo/object/_search/geo.json',
      //     url: "/jetlinksGeo/areas_v3/bound/100000.json",
      //     method: "GET"
      //   })
      //   .then((res) => {
      //     console.log(res)
      //     const data = res.data.result;
      //     data.features.map((item) => {
      //       item.geometry.coordinates.map((path) => {
      //         this.pathPolygon.push(path[0]);
      //       });
      //     });
      //   });
    },
    // getNotDeviceList() {
    //   window
    //     .axios({
    //       // url: '/jetlinks/geo/object/_search/geo.json',
    //       url: "/jetlinks/geo/object/device/_search/geo.json",
    //       method: "POST",
    //       data: {
    //         filter: {
    //           where: "objectType not device",
    //           pageSize: 1000,
    //         },
    //       },
    //     })
    //     .then((res) => {
    //       const data = res.data.result;
    //       data.features.map((item) => {
    //         item.geometry.coordinates.map((path) => {
    //           this.pathPolygon.push(path[0]);
    //         });
    //       });
    //     });
    // },
    getDeviceList() {
      let _this = this;
      return new Promise((resolve, reject) => {
        const filter = {
          paging: false,
        };

        // if (this.productId) {
        //   filter.where = `productId = ${this.productId}`;
        // }
        window
          .axios({
            // url: '/jetlinks/geo/object/_search/geo.json',
            url: "/jetlinks/geo/object/device/_search/geo.json",
            method: "POST",
            data: {
              filter: filter,
              // 'shape': {
              //   "objectId": 'chongqing',
              // }
            },
          })
          .then((res) => {
            if (res.status == 200) {
              const data = res.data.result;
              data.features.map((item, index) => {
                let _config = {};

                if (
                  !this.productId ||
                  this.productId == 'all' ||
                  item.properties.productId == this.productId
                ) {
                  if (_this.markerConfig) {
                    _config = this.markerConfig(
                      item,
                      _this.$refs.amap.$$getInstance()
                    );
                  }
                  _this.showIndex = index;
                  _this.markers.push({
                    lnglat: item.geometry.coordinates,
                    deviceInfo: item.properties,
                    icon: this.markImg || mark_b,
                    events: {
                      async click() {
                        let res = await window.axios({
                          url:
                            "/jetlinks/device/instance/" +
                            item.properties.objectId +
                            "/detail",
                          method: "GET",
                        });
                        _this.showDeviceInfo = res.data.result;
                        this.showIndex = index;
                        let result = res.data.result;
                        // console.log(result);
                        _this.updataShowInfo(index);

                        let productMetadata = JSON.parse(
                          result.productMetadata
                        );
                        let propertie = productMetadata.properties;
                        _this.propertie = propertie;
                        const topic = `/dashboard/device/${result.productId}/properties/realTime`;
                        let param = propertie.map((item) => item.id);
                        if (this.subDeviceInfo)
                          this.subDeviceInfo.unsubscribe();
                        // console.log(topic);
                        // console.log(param);
                        const id = `instance-info-property-view-${result.id}-${
                          result.productId
                        }-${param.join("-")}`;
                        _this.subDeviceInfo = window
                          .getWebSocket(id, topic, {
                            deviceId: result.id,
                            properties: param,
                            history: 1,
                          })
                          .subscribe((resp) => {
                            const { payload } = resp;
                            // console.log(payload);
                            if (payload.value.property == "geoPoint") {
                              const newLngLat = [
                                payload.value.value.lon,
                                payload.value.value.lat,
                              ];
                              _this.markers[index].lnglat = newLngLat; // 更新数据
                              if (_this.mapMarkers && _this.mapMarkers[index]) {
                                _this.mapMarkers[index].setPosition(newLngLat); // 更新地图上的点
                              }
                            } else if (payload.value.property) {
                              _this.messageCache.set(
                                payload.value.property,
                                payload
                              );
                            }
                            _this.updataShowInfo(index);
                          });
                      },
                    },
                    ..._config,
                  });
                  this.deviceIdList.push(item.properties.objectId);
                  this.windows.push({
                    position: item.geometry.coordinates,
                    content: "<div>没有信息</div>", //内容
                    offset: [5, -20], //窗体偏移
                    visible: false,
                  });
                }
              });
              resolve();
            } else {
              reject(res);
            }
          });
      });
    },
    updataShowInfo(index) {
      let _infoConfig = undefined;
      _infoConfig = this.infoWindowConfig1(index);
      this.windows.forEach((i) => {
        i.visible = false; //关闭窗体
      });

      if (_infoConfig) {
        this.$nextTick(() => {
          this.window.content = this._createInfoWindow(_infoConfig);
          this.window.position = this.markers[index].lnglat;
          this.window.visible = true;
        });
      }
    },
    infoWindowConfig1(index) {
      // console.log(data, map);
      // console.log(index);
      // console.log(this.markers[index]);
      // console.log(this.showDeviceInfo)
      let marker = this.markers[index];
      let lnglat = marker.lnglat;
      let data = this.showDeviceInfo;
      const propList = [...this.messageCache.values()];
      // console.log(propList)
      let propHtml = propList
        .map((item) => {
          let value = item.value;
          return `<strong>${
            this.propertie.find((item) => item.id == value.property).name
          }：</strong> ${value.formatValue ?? "未知"}<br/>`;
        })
        .join("");
      const now = new Date();
      const formatted = `${now.getFullYear()}-${(now.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")} ${now
        .getHours()
        .toString()
        .padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;

      return {
        title: "设备信息",
        content: `
      <div style="padding:10px;">
        <div><strong>设备名称：</strong>${data.name}</div>
        <div><strong>产品名称：</strong>${data.productName}</div>
        <div><strong>经度：</strong>${lnglat[0]}</div>
        <div><strong>纬度：</strong>${lnglat[1]}</div>
        <div style="text-align: center;">
                  ------设备参数------
                </div>
                ${propHtml || "<div>加载中...</div>"}
                <strong>更新时间：</strong> ${formatted} <br/>
      </div>
    `,
        bodyStyle: {
          backgroundColor: "#242424",
          border: "1px solid #fff",
          color: "#fff",
        },
        titleTextStyle: { fontSize: "16px" },
        closeBtnStyle: { color: "#fff" },
      };
    },
    clearMap() {
      // 清 marker
      this.markers = [];
      this.deviceIdList = [];
      // 清 websocket
      this.destroyed();

      // 清聚合
      if (this.cluster) {
        this.cluster.clearMarkers();
      }
      if (this.mapMarkers && this.mapMarkers.length) {
        this.mapMarkers.forEach((m) => m.setMap(null));
        this.mapMarkers = [];
      }
    },
    changeProduct(productId) {
      this.productId = productId;
      this.clearMap();
      this.updataMapInfo(false);
    },
    getRealTimeDeviceInfo() {
      if (this.deviceTime) return;
      // this.deviceTime = setInterval(() => {
      //   window.getWebSocket("location-info-status-by-array-deviceId",
      //     "/device-current-state", {
      //       "deviceId": this.deviceIdList,
      //     }).subscribe((resp) => {
      //   const {payload} = resp;
      //   let key = Object.keys(payload)[0]
      //   this.markers.forEach(item => {
      //     if(key == item.deviceInfo.objectId){
      //       item.icon = payload[key] === 'online' ? mark_b : mark_r;
      //     }
      //   })
      // })
      // }, 3000)
      this.subDeviceCurrentStatus = window
        .getWebSocket(
          "location-info-status-by-array-deviceId",
          "/device-current-state",
          {
            deviceId: this.deviceIdList,
          }
        )
        .subscribe((resp) => {
          const { payload } = resp;
          let key = Object.keys(payload)[0];
          this.markers.forEach((item, index) => {
            if (key === item.deviceInfo.objectId) {
              item.icon = this.markImg;
              item.status = payload[key];

              // 更新地图 Marker 的图标
              if (this.mapMarkers && this.mapMarkers[index]) {
                this.mapMarkers[index].setIcon(item.icon);
              }
            }
          });
        });

      this.subDeviceStatus = window
        .getWebSocket(
          "all-device-info-status-by-array-deviceId",
          "/device/*/*/online,offline",
          {}
        )
        .subscribe((resp) => {
          const { payload } = resp;
          let key = payload.deviceId;
          this.markers.forEach((item, index) => {
            if (key == item.deviceInfo.objectId) {
              console.log;
              item.icon = this.markImg;
              item.status =
                payload.messageType === "ONLINE" ? "online" : "offline";
              // item.status = payload.messageType;
              // 同步更新地图上的图标
              if (this.mapMarkers && this.mapMarkers[index]) {
                this.mapMarkers[index].setIcon(item.icon);
              }
              if (index == this.showIndex) {
                if (this.window.visible) {
                  this.updataShowInfo(index);
                }
              }
            }
          });
        });
    },
    getRealTimeProperties(deviceId, productId) {
      this.subProperties = window
        .getWebSocket(
          "location-info-property-" + deviceId,
          "/dashboard/device/" + productId + "/properties/realTime",
          {
            deviceId: deviceId,
            history: 1,
          }
        )
        .subscribe((resp) => {
          const { payload } = resp;
          this.payloadPropertiesValue = payload.value;
        });
    },
    getRealTimeEvent(deviceId, productId) {
      this.subEvents = window
        .getWebSocket(
          "location-info-event-" + deviceId + "-" + productId,
          "/dashboard/device/" + productId + "/events/realTime",
          {
            deviceId: deviceId,
            history: 1,
          }
        )
        .subscribe((resp) => {
          const { payload } = resp;
          this.payloadEventsValue = payload.value;
        });
    },
    _createInfoWindow(config) {
      const infoBody = document.createElement("div");
      const infoCloseBtn = document.createElement("div");
      const infoTitle = document.createElement("div");
      const infoTitleText = document.createElement("div");
      const _this = this;
      infoCloseBtn.innerHTML = "×";

      infoBody.className = "jetlinks-amap-infowindow";
      infoTitle.className = "jetlinks-amap-infowindow-infoTitle";
      infoCloseBtn.className = "jetlinks-amap-infowindow-close";

      infoTitleText.innerHTML = config.title || "";
      infoTitle.appendChild(infoTitleText);
      infoTitle.appendChild(infoCloseBtn);

      infoBody.style = { ...infoBody.style, ...config.bodyStyle };
      infoCloseBtn.style = { ...infoCloseBtn.style, ...config.closeBtnStyle };

      _this.updateStyle(infoBody, config.bodyStyle);
      _this.updateStyle(infoTitle, config.infoTitleStyle);
      _this.updateStyle(infoCloseBtn, config.closeBtnStyle);
      _this.updateStyle(infoTitleText, config.titleTextStyle);

      infoCloseBtn.onclick = () => {
        _this.window.visible = false;
        this.subDeviceInfo && this.subDeviceInfo.unsubscribe();
      };

      if (config.content) {
        infoBody.innerHTML = config.content;
      }
      infoBody.insertBefore(infoTitle, infoBody.childNodes[0]);

      return infoBody;
    },
    updateStyle(dom, style) {
      for (const key in style) {
        dom.style[key] = style[key];
      }
    },
    createInfoWindow(
      deviceName,
      status,
      productId,
      productName,
      properties,
      event
    ) {
      return `<div class="window-box">
        <div style="display: flex;width: 100%;height: 60px;color: white;">
          <div style="display: flex;justify-content: center; width: 80px;height: 50px;">
            <img style="width: 50px;height: 50px;" src="data:image/svg+xml;base64,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"/>
          </div>
          <div style="width: 300px; font-size: 12px;">
            <div style="display: flex;width: 100%;justify-content: space-around;height: 25px;line-height: 25px;">
              <div style="font-size: 14px; font-weight: 600;">${deviceName}</div>
            </div>
            <div style="display: flex;width: 100%;justify-content: space-around;height: 25px;line-height: 25px;">
              <div>ID: ${productId}</div>
              <div>产品： ${productName}</div>
            </div>
          </div>
        </div>
        <div style="width: 100%;">
          ${properties
            .map(
              (i) => `<div v-for="item in metadata" class="box-item">
              <div style="display: flex">
                <div class="box-title">${i.name}</div>
                <div>${
                  this.payloadPropertiesValue.propertyName == i.name
                    ? this.payloadPropertiesValue.formatValue
                    : "/"
                }</div>
              </div>
            </div>`
            )
            .join("")}
           ${event
             .map(
               (i) => `<div v-for="item in metadata" class="box-item">
              <div style="display: flex">
                <div class="box-title">${i.name}</div>
                <div>${
                  this.payloadEventsValue.propertyName == i.name
                    ? this.payloadEventsValue.formatValue
                    : "/"
                }</div>
              </div>
            </div>`
             )
             .join("")}
        </div>
      </div>`;
    },
    destroyed() {
      this.subDeviceStatus && this.subDeviceStatus.unsubscribe();
      this.subDeviceCurrentStatus && this.subDeviceCurrentStatus.unsubscribe();
      this.subDeviceInfo && this.subDeviceInfo.unsubscribe();
      this.subProperties && this.subProperties.unsubscribe();
      this.subEvents && this.subEvents.unsubscribe();
      // clearInterval(this.deviceTime)
    },
  },
});
</script>

<style>
.device-map-cluster:hover {
  filter: brightness(1.15);
}
.jetlinks-amap-infowindow {
  background-color: #fff;
  min-width: 200px;
  border-radius: 4px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
}
.jetlinks-amap-infowindow-infoTitle {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.jetlinks-amap-infowindow-close {
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
}
</style>
